import React, { useContext } from 'react';

import { ServiceResponse } from '../../../app/services/shared/interfaces';

import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';
import ActiveControl from '../../../components/ActiveControl';
import useUserResponseService from '../../../app/services/hooks/useUserResponseService';

interface Props {
    userResponseId: number;
    checkValue: boolean;
    callbackSuccess: () => void;
}

const UserResponseSwitchChange = ({ userResponseId, checkValue, callbackSuccess }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const [checked, setChecked] = React.useState<boolean>(checkValue);

    const { activeUserResponse, fetchingActiveUserResponse } = useUserResponseService();

    const active = (value: boolean) => {
        setChecked(value);

        activeUserResponse(userResponseId, value, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });

                callbackSuccess();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setChecked(!value);
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    return <ActiveControl status={checked} id={userResponseId} callback={active} />;
};

export default UserResponseSwitchChange;
